import React from 'react'
import tw from 'tailwind-styled-components'
import {AccordionHeaderStyle, AccordionItem} from './accordion-item'
import {AccordionItemData} from './types'

const TwAccordion = tw.div`
  w-full
`
TwAccordion.displayName = 'TwAccordion'

export interface AccordionBaseProps {
  items: AccordionItemData[]
  headerStyle?: AccordionHeaderStyle
  openedIds: string[]
  onItemClick: (id: string | undefined) => void
  disabled?: boolean
  className?: string
}

// todo: animation!
/**
 * Controlled accordion component
 */
export const AccordionBase = ({
  items,
  openedIds,
  onItemClick,
  disabled,
  className,
  headerStyle
}: AccordionBaseProps) =>
  items.length ? (
    <TwAccordion className={className}>
      {items.map(item => (
        <AccordionItem
          key={item.id}
          item={item}
          opened={openedIds.includes(item.id)}
          onClick={onItemClick}
          disabled={disabled || item.disabled}
          headerStyle={headerStyle}
        />
      ))}
    </TwAccordion>
  ) : null
